<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="text-center" style="margin-bottom: 5px">
              <h1 class="text-white">Activis Manager</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h2>Connexion</h2>
              </div>
              <form role="form" @submit.prevent="handleSubmit()">
                <base-input
                  alternative
                  class="mb-3"
                  name="username"
                  prepend-icon="fa fa-user"
                  placeholder="Identifiant"
                  v-model="username"
                />
                <validation-error :errors="apiValidationErrors.username" />

                <base-input
                  alternative
                  class="mb-3"
                  name="Password"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                >
                </base-input>
                <validation-error :errors="apiValidationErrors.password" />

                <div class="text-center">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >Connexion</base-button
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <a
                href="https://chirurgiequebec.ca/section-des-membres"
                target="_blank"
                class="text-light"
                ><small>Mot de passe oublié?</small></a
              >
            </div>
            <div class="col-6 text-right">
              <a
                href="https://chirurgiequebec.ca/section-des-membres"
                target="_blank"
                class="text-light"
                ><small>Creer un compte</small></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
export default {
  components: {
    ValidationError,
  },

  mixins: [formMixin],

  data: () => ({
    username: null,
    password: null,
  }),

  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
  },

  methods: {
    async handleSubmit() {
      const user = {
        data: {
          type: "token",
          attributes: {
            username: this.username,
            password: this.password,
          },
        },
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Identifiants invalides!",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
